// extracted by mini-css-extract-plugin
export default {"button":"EditAdminsPopup_button__5w-w8","input":"EditAdminsPopup_input__LyjDn","values":"EditAdminsPopup_values__RDi14","header":"EditAdminsPopup_header__tFGu4"};